/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessViolationsTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AccessViolationsTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return AccessViolationsTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AccessViolationsTrendWidgetConfiguration>): AccessViolationsTrendWidgetConfiguration {
        let obj = Object.assign(new AccessViolationsTrendWidgetConfiguration(), model);
        AccessViolationsTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessViolationsTrendWidgetConfiguration>): AccessViolationsTrendWidgetConfiguration {
        if (!model) return null;
        return AccessViolationsTrendWidgetConfiguration.newInstance(<AccessViolationsTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessViolationsTrendWidgetConfiguration) {
        if (!obj) return;

        models.AccessViolationsTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessViolationsTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AccessViolationsTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
